import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Gallery = () => {

  const images = [
    { id: 1, src: '/images/ourfleet/1.jpg', alt: 'Image 1' },
    { id: 2, src: '/images/ourfleet/2.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/ourfleet/3.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/ourfleet/4.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/ourfleet/5.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/ourfleet/6.jpg', alt: 'Image 6' },
    { id: 7, src: '/images/ourfleet/7.jpg', alt: 'Image 7' },
    { id: 8, src: '/images/ourfleet/8.jpg', alt: 'Image 8' },
    { id: 9, src: '/images/ourfleet/9.jpg', alt: 'Image 9' },
    { id: 10, src: '/images/ourfleet/10.jpg', alt: 'Image 10' },
    { id: 11, src: '/images/ourfleet/11.jpg', alt: 'Image 11' },
    { id: 12, src: '/images/ourfleet/12.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/13.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/14.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/15.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/16.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/17.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/18.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/19.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/20.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/21.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/22.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/23.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/24.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/25.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/26.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/27.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/28.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/29.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/30.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/31.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/32.jpg', alt: 'Image 12' },
    { id: 12, src: '/images/ourfleet/33.jpg', alt: 'Image 12' },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <>
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>Gallery</h1>
        </div>
      </div>

      <div className="gallery-container">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div className="col-md-4 col-sm-6 col-xs-12" key={image.id}>
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image-item borderr"
                  onClick={() => openModal(index)} // Open the modal on click
                />
              </div>
            ))}
          </div>
        </div>

        {/* Modal */}
        {isModalOpen && (
          <div className="modal-overlay">
            <button className="modal-close-button" onClick={closeModal}>
              &times;
            </button>
            <div className="modal-content-container">
              <button className="modal-prev-button" onClick={prevImage}>
                &#10094;
              </button>
              <div className="modal-image-container">
                <img
                  src={images[currentImageIndex].src}
                  alt={images[currentImageIndex].alt}
                  className="modal-image"
                />
              </div>
              <button className="modal-next-button" onClick={nextImage}>
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;
